import Api from '@/api/config.ts';
import { apiUrls } from '@/api/api-urls.ts';
import {
  InvoiceRequestPayload,
  InvoiceResponse
} from '@/api/purchases/types.ts';
import { SubscriptionPurchase } from '@/api/login/types.ts';

const createInvoice = async (payload: InvoiceRequestPayload) => {
  const response = await Api.post<InvoiceResponse>(
    apiUrls.purchases.createInvoice,
    payload
  );

  return response.data;
};

const getSubscription = async () => {
  const response = await Api.get<{ purchases: SubscriptionPurchase[] }>(
    apiUrls.purchases.getSubscription
  );

  return response.data;
};

const PurchaseController = {
  createInvoice,
  getSubscription
};

export default PurchaseController;
